import * as type from "./constants";
const initialState = {
  loading: false,
  searchAllocators: [],
  allocatorDetail: [],
  rows: null,
  page:1,
};

export default function searchAllocatorReducer(state = initialState, action) {
  switch (action.type) {
    case type.GET_SEARCH_ALLOCATORS_REQUEST:
      return { ...state, loading: true };
    case type.GET_SEARCH_ALLOCATORS_SUCCESS:
      const isFirstPage = Boolean(action.payload.page === 1);
      return {
        ...state,
        loading: false,
        rows: action.payload.rows,
        searchAllocators: isFirstPage
          ? action.payload.items
          : [...state.searchAllocators, ...action.payload.items],
        page: action.payload.page
      };
    case type.GET_SEARCH_ALLOCATORS_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
